module.exports = __webpack_public_path__ + "static/media/frog.7bc267c6.mp4";